import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { OnboardingInvite } from 'src/api/onboardingInvites';

type CreateOnboardingInviteRequest = {
  email: string;
  companyName: string;
  frn: string;
};

export const useCreateOnboardingInvite = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    error,
    reset,
  } = useMutation<{ data: OnboardingInvite }, Error, CreateOnboardingInviteRequest>({
    mutationFn: values => api.post<OnboardingInvite>('admin/onboarding-invites', values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'onboarding-invites'] });
    },
  });

  return { createInvite: mutateAsync, isLoading, error, reset };
};
